import { Suspense, lazy, useEffect } from "react";
import { useLocation } from "react-router-dom";
import { Navigate, Route, Routes } from "react-router-dom";
import IndexPage from "@/components/IndexPage";
import { AnnouncementToast } from "@/components/announcement/AnnouncementToast";
import { SmoothScroll } from "@/components/SmoothScroll";

const OAuthCallbackGooglePage = lazy(() => import("@/pages/OAuthCallbackGooglePage"));
const BillingCheckoutSuccessPage = lazy(() => import("@/pages/BillingCheckoutSuccessPage"));
const NotFoundPage = lazy(() => import("@/pages/NotFoundPage"));

function RouteFallback() {
  return (
    <div
      className="flex min-h-[40vh] items-center justify-center bg-background"
      role="status"
      aria-label="Loading"
    >
      <div className="h-8 w-8 animate-spin rounded-full border-2 border-primary border-t-transparent" />
    </div>
  );
}

export function App() {
  const { pathname } = useLocation();

  useEffect(() => {
    // When a hash anchor is present, skip scrollTo(0) so useHashScroll can handle it.
    if (window.location.hash) return;
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  return (
    <>
      {/* 全局高性能平滑滚动 */}
      <SmoothScroll />
      {/* 站点公告 Toast（右下角自动弹出最新更新；详见 AnnouncementToast） */}
      <AnnouncementToast />
      <Suspense fallback={<RouteFallback />}>
      <Routes>
        <Route path="/" element={<IndexPage />} />
        <Route path="/solutions" element={<IndexPage />} />
        <Route path="/solution" element={<IndexPage />} />
        <Route path="/models" element={<IndexPage />} />
        <Route path="/creators" element={<IndexPage />} />
        <Route path="/products" element={<IndexPage />} />
        <Route path="/library" element={<IndexPage />} />
        <Route path="/pricing" element={<IndexPage />} />
        <Route path="/company" element={<IndexPage />} />
        <Route path="/about" element={<IndexPage />} />
        <Route path="/register" element={<IndexPage />} />
        <Route path="/api/oauth/callback/google" element={<OAuthCallbackGooglePage />} />
        <Route path="/billing/checkout/success" element={<BillingCheckoutSuccessPage />} />
        <Route path="/home" element={<Navigate to="/" replace />} />
        <Route path="/404" element={<NotFoundPage />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
      </Suspense>
    </>
  );
}
